<div
  class="lum-c-sales-order-group-column"
  [ngClass]="{ 'lum-c-sales-order-group-column--row': isRow }"
  (click)="toggleGroup()"
>
  <ng-container *ngIf="doesRender">
    <ng-container *ngIf="group; else whenNoGroup">
      <i
        class="
          lum-c-sales-order-group-column__open-indicator fa-fw fas fa-chevron-right
        "
        [ngClass]="{ 'fa-rotate-90': isExpanded }"
        role="presentation"
      ></i>
      <span
        ><b>{{ group.label }}</b> ({{ group.count }})</span
      >
    </ng-container>
    <ng-template #whenNoGroup>
      <span class="mx-4">{{ isGridLoading ? '...' : 'None' }}</span>
    </ng-template>
  </ng-container>
</div>
